import FoodResult from "../food/FoodResult"
import FoodSearch from "../food/FoodSearch"

function Home() {
  return (
    <>
         
        <FoodSearch/>
        <FoodResult/>
    </>
  )
}

export default Home